<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header mb-4"
    >
      <div class="md-layout">
        <div
          class="md-layout-item md-medium-size-100 md-size-100 truncated_header2"
        >
          <div class="md-layout md-alignment-center">
            <!--<div class="md-layout-item md-medium-size-50 md-size-50 p-0">
            <div class="logo_wpr p-0">
              <img v-if="this.user.companyLogo" :src="this.user.companyLogo" class="logo"/>
              <h4>{{this.user.companyName}}</h4>
            </div>
          </div>-->
            <div
              class="md-layout-item md-medium-size-100 md-medium-size-60 md-xsmall-size-100 md-size-60 p-0 report-header"
            >
              <h4>{{ this.headerData.title + ": " }}</h4>
              <ul>
                <li>
                  <h6><i class="md-icon">business_center</i>Industry:</h6>
                  <p>
                    [{{ parseFloat(this.headerData.bznaics) }}]
                    {{ this.headerData.industry }}
                  </p>
                </li>
                <li>
                  <h6><i class="md-icon">apartment</i>Sector:</h6>
                  <p>{{ this.headerData.sector }}</p>
                </li>
                <li>
                  <h6><i class="md-icon">place</i>Market Area:</h6>
                  <p>{{ this.headerData.area }}</p>
                </li>
                <li>
                  <h6><i class="md-icon">equalizer</i>Sales Class:</h6>
                  <p>{{ this.headerData.sales_class }}</p>
                </li>
              </ul>
            </div>
            <div
              class="md-layout-item md-medium-size-100 md-xsmall-size-50 md-size-40 button-box"
            >
              <md-button
                class="md-info access-button pdf_btn"
                @click="feedback"
              >
                <md-icon>comment</md-icon>Product Feedback
              </md-button>
              <md-button
                v-if="vestimateReport === {}"
                class="md-info access-button pdf_btn"
              >
                <template>
                  <md-icon class="ml-5">picture_as_pdf</md-icon>Loading...
                </template>
              </md-button>
              <md-button
                v-if="pdfLoading"
                class="md-info access-button pdf_btn"
              >
                <template>
                  <md-icon class="ml-5">picture_as_pdf</md-icon>Downloading...
                </template>
              </md-button>
              <md-button
                v-if="vestimateReport !== {} && !pdfLoading"
                target="_blank"
                class="md-info access-button pdf_btn"
                @click="generateReport"
              >
                <md-icon class="ml-5">picture_as_pdf</md-icon>Download PDF
              </md-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="md-layout-item md-size-100" v-if="user && headerData">
      <VRPDF :headerData="headerData" :user="user" ref="html2Pdf" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import VRPDF from "./VRPDF.vue";
import axios from "axios";

export default {
  components: {
    VRPDF,
  },
  props: ["headerData", "analysis", "checkData"],
  data() {
    return {
      feedbackModal: false,
      textFeedback: "",
      optionsCategory: {
        0: "Select a Category",
        1: "1 - Report an Error",
        2: "2 - Suggest an Improvement",
        3: "3 - Request a Correction",
        4: "4 - Request an Update",
      },

      category: 0,

      valuationLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 80,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "300px",
        },
      },
      historiacalLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 80,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "300px",
        },
      },
      sales_value: "",
      sales_growth: "",
      earning_value: "",
      earning_growth: "",
      historical_earnings: [],
      historical_income: [],
      chartYears: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state?.user?.user,
      client: (state) => state?.user?.vestimate_report?.data?.developerClient,
      vestimateReport: (state) => state?.user?.vestimate_report?.data,
      vestimateScores: (state) => {
        if (
          state?.user?.vestimate_report?.data &&
          state?.user?.vestimate_report?.data?.IF
        ) {
          return state?.user?.vestimate_report?.data?.IF["scores"];
        }
        return "";
      },
      naics: (state) => state?.user?.vestimate_report?.data?.IMRnaics,
      industryName: (state) => state?.user?.vestimate_report?.data?.IMRindustry,
      displayArea: (state) => state?.user?.vestimate_report?.data?.MR?.area,
      reportDate: (state) => state?.user?.vestimate_report?.data?.report_date,
      recentYear: (state) => state?.user?.vestimate_report?.data?.recentYear,
      companyName: (state) =>
        state?.user?.vestimate_report?.data?.input_structure
          ? state?.user?.vestimate_report?.data?.input_structure[
              "Company Name"
            ]["value"]
          : "",
      all_us: (state) => state?.user?.vestimate_report?.data?.all_us,
      opp_index_exclude: (state) =>
        state?.user?.vestimate_report?.data?.opp_index_exclude,
      pdfLoading: (state) => state.user.pdfLoading,
    }),
    pdfDownloadSetting() {
      return this.user &&
        this.user.preferences &&
        this.user.preferences.defaultPDFDownload
        ? this.user.preferences.defaultPDFDownload
        : "_blank";
    },
  },

  mounted() {
    this.$store.commit("user/SET_PDF_LOADING", false);
  },
  methods: {
    ...mapActions({
      registerProductExport: "tracking/registerProductExport",
    }),
    numberWithPoints(x) {
      if (typeof x === "number") {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else if (x === null) {
        return x;
      } else {
        return x.replace(/,/g, ".");
      }
    },
    generateReport() {
      this.$refs.html2Pdf.generateReport2();
      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: "PDF",
      });
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          if (!this.$store.getters["user/pdfMustBeDownloaded"])
            window.open(pdf.output("bloburl"), "_blank");
        });
    },
    feedback() {
      this.feedbackModal = true;
    },
    sendFeedback() {
      let parameters = {};

      parameters["name"] = this.headerData.title;
      parameters["Industry"] = this.headerData.industry;
      parameters["Area"] = this.headerData.area;
      parameters["Sales Class"] = this.headerData.sales_class;
      parameters = JSON.stringify(parameters);

      if (this.category) {
        let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
        );
        axios
          .post(
            process.env.VUE_APP_API_BASE_URL + "/user/feedback/submit",
            {},
            {
              params: {
                session_id: currentSession,
                feedback: this.textFeedback,
                url: `${window.location.href}`,
                category: this.category,
                parameters: parameters,
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
              );
              throw new Error(
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            if (res.data.success)
              this.$store.dispatch("alerts/success", "Data saved.");
            else
              this.$store.dispatch(
                "alerts/error",
                "An error occured. please try again"
              );

            this.feedbackModal = false;
            this.textFeedback = null;
            this.category = null;

            this.checkBoxOption1 = false;
            this.checkBoxOption2 = false;
            this.checkBoxOption3 = false;
            this.checkBoxOption4 = false;
          });
      } else {
        this.$store.commit("SET_ERROR_BIT", true);
        this.$store.commit(
          "SET_ERROR_INFO",
          "<br>" +
            "Server responded with error = True <br> errorCode: " +
            "category_not_set" +
            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
        );
      }
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return x;
      }
    },
  },
};
</script>
